import { createStore } from 'jotai';
import { layoutAtom, widgetPanelVisibilityAtom } from '@components/metrics-panel-hz/atoms';
import { summaryPanelAtom } from '@src/atoms/panels';

function initStore() {
  const store = createStore();
  store.set(layoutAtom, '4l');
  store.set(summaryPanelAtom, false);
  store.set(widgetPanelVisibilityAtom, false);
  return store;
}

export default initStore;
